// operator.ts — CORE-1661
//
// Как экраны согласий называют оператора. Для российского контура это АО —
// сторона соглашения и политики с 01.10.2026 (CORE-1555, CORE-1541); вне его —
// AGAPE.IO Limited. Кто из двух — решает `utils/legalJurisdiction`, то же
// правило, что выбирает редакцию соглашения (см. `currentOperator` в
// `accepted.ts`). Язык экрана на оператора не влияет.
//
// Файл без импортов: `scripts/legal-editions/documents.js` читает
// `OPERATOR_NAMES` разбором исходника, чтобы собрать текст каждой редакции.

export type LegalOperator = 'ru' | 'intl';

export const OPERATOR_NAMES = {
  ru: { ru: 'АО «Цифровая ИИ Трансформация»', en: 'JSC «Tsifrovaya II Transformatsiya»' },
  intl: { ru: 'AGAPE.IO Limited', en: 'AGAPE.IO Limited' },
};

/** Место для названия оператора в текстах согласий. */
export const OPERATOR_PLACEHOLDER = '{operator}';

export function withOperator(text: string, operator: LegalOperator, lang: 'ru' | 'en'): string {
  return text.split(OPERATOR_PLACEHOLDER).join(OPERATOR_NAMES[operator][lang]);
}
